import bar from "./bar-chart.svg";
import bubble from "./bubble-chart.svg";
import doughnut from "./doughnut-chart.svg";
import line from "./line-chart.svg";
import pie from "./pie-chart.svg";
import polarArea from "./polarArea-chart.svg";
import radar from "./radar-chart.svg";
import scatter from "./scatter-chart.svg";

export default { bar, bubble, doughnut, line, pie, polarArea, radar, scatter };
